@if (!loading) {
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" class="panel form-panel">
        @if (this.title !== '') {
            <h1 class="form-panel__title">{{ title }}</h1>
        }

        <div class="form-grid form-panel__fields">
            @for (field of fields; track $index) {
                @if (field.disabled !== true) {
                    <div class="form-group" [class.form-group--check]="field.type === 'checkbox'">
                        @if (field.type === 'checkbox') {
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" autocomplete="off" id="{{ field.name }}" formControlName="{{ field.name }}" value="{{field.value}}">
                                <label class="form-check-label" for="{{ field.name }}">{{ field.label }}</label>
                            </div>
                        } @else if (field.type === 'select') {
                            <label class="form-label" for="{{ field.name }}">{{ field.label }}</label>
                            <select class="form-select" [id]="field.name" [attr.aria-label]="field.label" [value]="field.value" (change)="field.options ? changeStaticSelected({id: $event, key: field.name}) : changeSelected({id: $event, key: field.name})">
                                @if (field.options) {
                                    @for (option of field.options; track option.value) {
                                        <option [value]="option.value" [selected]="option.value === field.value">{{ option.label }}</option>
                                    }
                                } @else {
                                    @for (selectField of this[field.arrayKey!]; track $index) {
                                        @if (field.name.includes('ejercicio')) {
                                            <option [value]="selectField.id" [selected]="Number(field.value) === $index">{{ selectField.ejercicio }}</option>
                                        } @else if (field.name.includes('tipo_asociacion')) {
                                            <option [value]="selectField.id" [selected]="Number(field.value) === $index">{{ selectField.tipo | titlecase }}</option>
                                        } @else {
                                            <option [value]="selectField.id" [selected]="Number(field.value) === $index">{{ selectField.nombre | titlecase }}</option>
                                        }
                                    }
                                }
                            </select>
                        } @else {
                            <label class="form-label" for="{{ field.name }}">{{ field.label }}</label>
                            <input [type]="field.type" id="{{ field.name }}" class="form-control" formControlName="{{ field.name }}" value="{{field.value}}" [disabled]="field.disabled!">
                        }
                    </div>
                }
            }
        </div>
        <div class="form-actions form-panel__actions">
            @for (button of buttons; track $index) {
                <button [class]="button.class" [type]="button.type" (click)="button.action(formulario, functionSelected, service, type, alertService)">{{ button.text }}</button>
            }
        </div>
    </form>
}
